(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _navigation = _interopRequireDefault(require("./animations/navigation"));

var _homeBanner = _interopRequireDefault(require("./animations/homeBanner"));

var _homeIntro = _interopRequireDefault(require("./animations/homeIntro"));

var _highlightText = _interopRequireDefault(require("./animations/highlightText"));

var _ticketWidget = _interopRequireDefault(require("./animations/ticketWidget"));

var _twitterGrid = _interopRequireDefault(require("./animations/twitterGrid"));

var _faq = _interopRequireDefault(require("./animations/faq"));

var _footer = _interopRequireDefault(require("./animations/footer"));

var _innerBanner = _interopRequireDefault(require("./animations/innerBanner"));

var _comingSoon = _interopRequireDefault(require("./animations/comingSoon"));

var _imageBreak = _interopRequireDefault(require("./animations/imageBreak"));

var _keynoteHome = _interopRequireDefault(require("./animations/keynote-home"));

var _keynoteInner = _interopRequireDefault(require("./animations/keynote-inner"));

var _copyBlocks = _interopRequireDefault(require("./animations/copyBlocks"));

var _charityBlocks = _interopRequireDefault(require("./animations/charityBlocks"));

var _charityTy = _interopRequireDefault(require("./animations/charityTy"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function animations() {
  (0, _navigation["default"])();
  (0, _homeBanner["default"])();
  (0, _homeIntro["default"])();
  (0, _highlightText["default"])();
  (0, _keynoteHome["default"])();
  (0, _ticketWidget["default"])();
  (0, _twitterGrid["default"])();
  (0, _faq["default"])();
  (0, _footer["default"])();
  (0, _innerBanner["default"])();
  (0, _comingSoon["default"])();
  (0, _imageBreak["default"])();
  (0, _keynoteInner["default"])();
  (0, _copyBlocks["default"])();
  (0, _charityBlocks["default"])();
  (0, _charityTy["default"])();
}

var _default = animations;
exports["default"] = _default;

},{"./animations/charityBlocks":2,"./animations/charityTy":3,"./animations/comingSoon":4,"./animations/copyBlocks":5,"./animations/faq":6,"./animations/footer":7,"./animations/highlightText":8,"./animations/homeBanner":9,"./animations/homeIntro":10,"./animations/imageBreak":11,"./animations/innerBanner":12,"./animations/keynote-home":13,"./animations/keynote-inner":14,"./animations/navigation":15,"./animations/ticketWidget":16,"./animations/twitterGrid":17}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function charityBlocks() {
  var allSelectCharities = document.querySelectorAll('.select-charity');
  allSelectCharities.forEach(function (select) {
    select.addEventListener('click', function () {
      var id = select.dataset.id;
      var confirmation = document.querySelector(".confirmation[data-id=".concat(id, "]"));
      confirmation.classList.add('active');
    });
  });

  function closeModal() {
    var allConfirmations = document.querySelectorAll('.confirmation');
    allConfirmations.forEach(function (modal) {
      return modal.classList.remove('active');
    });
  }

  var allCancelBtns = document.querySelectorAll('.confirmation .cancel');
  allCancelBtns.forEach(function (btn) {
    btn.addEventListener('click', closeModal);
  });
  var clickTarget = $('.confirmation .content-wrapper');
  $('body').mouseup(function (e) {
    if (e.target.id != clickTarget.attr('id') && !clickTarget.has(e.target).length) {
      closeModal();
    }
  });
}

function charityBlocksInit() {
  if (document.querySelector('.charity-blocks')) {
    charityBlocks();
  }
}

var _default = charityBlocksInit;
exports["default"] = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function charityTy() {
  var footer = document.querySelector('footer');
  footer.classList.add('flat-top');
  var banner = document.querySelector('.charity-ty');
  setTimeout(function () {
    banner.classList.add('animated');
  }, 800);
  var charityTySquare = document.querySelector('.charity-ty .accent-square');
  var charityTyYellow = document.querySelector('.charity-ty .accent-line.yellow');
  var charityTyWhite = document.querySelector('.charity-ty .accent-line.white');
  var charityTyDots = document.querySelector('.charity-ty .accent-dots');

  if (charityTySquare) {
    setTimeout(function () {
      charityTySquare.classList.add('loaded');
      charityTyWhite.classList.add('loaded');
    }, 2000);
    setTimeout(function () {
      charityTyYellow.classList.add('loaded');
      charityTyDots.classList.add('loaded');
    }, 2600);
  }
}

function charityTyInit() {
  if (document.querySelector('.charity-ty')) {
    charityTy();
  }
}

var _default = charityTyInit;
exports["default"] = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function comingSoon() {
  var comingSoon = document.querySelector('.coming-soon h2');
  var comingSoonAccent = document.querySelector('.coming-soon .accent-line');
  ScrollTrigger.create({
    trigger: comingSoon,
    start: "top 80%",
    onEnter: function onEnter() {
      comingSoon.classList.add('animated');
      comingSoonAccent.classList.add('faded');
    }
  }); // Accent

  gsap.to(".coming-soon .accent-line", {
    scrollTrigger: {
      trigger: ".coming-soon .accent-line",
      scrub: true
    },
    y: -100
  });
}

function comingSoonInit() {
  if (document.querySelector('.coming-soon')) {
    comingSoon();
  }
}

var _default = comingSoonInit;
exports["default"] = _default;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function copyBlocks() {
  var content = document.querySelector('.copy-blocks .content-wrapper');
  var blocks = document.querySelector('.copy-blocks .blocks-wrapper');
  var copyBlocksAccent = document.querySelector('.copy-blocks .accent-line');
  ScrollTrigger.create({
    trigger: content,
    start: "top 70%",
    onEnter: function onEnter() {
      copyBlocksAccent.classList.add('faded');
    }
  });
  ScrollTrigger.create({
    trigger: '.copy-blocks .blocks-wrapper',
    start: 'top 65%',
    onEnter: function onEnter() {
      var handleBlocks = Splitting({
        target: blocks,
        by: 'items',
        matching: '.block'
      });
    }
  }); // Accent

  gsap.to(".copy-blocks .accent-line", {
    scrollTrigger: {
      trigger: ".copy-blocks .accent-line",
      scrub: true
    },
    y: -100
  });
}

function copyBlocksInit() {
  if (document.querySelector('.copy-blocks')) {
    copyBlocks();
  }
}

var _default = copyBlocksInit;
exports["default"] = _default;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function faq() {
  var imgBreak = document.querySelector('.image-break');
  var faqQuestions = document.querySelector('.faq .accordion-wrapper');
  ScrollTrigger.create({
    trigger: '.faq',
    start: "top 150%",
    onEnter: function onEnter() {
      imgBreak.classList.add('trigger-angle');
    }
  });
  ScrollTrigger.create({
    trigger: '.faq .accordion-wrapper',
    start: "top 120%",
    onEnter: function onEnter() {
      var handleFaqQuestions = Splitting({
        target: faqQuestions,
        by: 'items',
        matching: '.accordion-item'
      });
    }
  });
  ScrollTrigger.matchMedia({
    "(min-width: 768px)": function minWidth768px() {
      gsap.to(".image-break span.angle", {
        scrollTrigger: {
          trigger: ".image-break",
          start: "top 0%",
          end: "bottom 0%",
          scrub: true
        },
        bottom: "-100px",
        skewY: "8deg"
      });
    }
  }); // Accents

  var faqAccentLine = document.querySelector(".faq .accent-line");
  var faqAccentTitle = document.querySelector(".faq .accent-title");
  var faqAccentDots = document.querySelector(".faq .accent-dots");
  ScrollTrigger.create({
    trigger: faqAccentLine,
    onEnter: function onEnter() {
      faqAccentLine.classList.add('faded');
      faqAccentTitle.classList.add('faded');
      faqAccentDots.classList.add('faded');
    }
  });
}

function faqInit() {
  if (document.querySelector('.faq')) {
    faq();
  }
}

var _default = faqInit;
exports["default"] = _default;

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function footer() {
  var footerSection = document.querySelector('footer');
  ScrollTrigger.create({
    trigger: 'footer',
    start: 'top 150%',
    onEnter: function onEnter() {
      footerSection.classList.add('trigger-angle');
    }
  }); // Accents

  var footerAccentPink = document.querySelector("footer .accent-line.pink");
  var footerAccentYellow = document.querySelector("footer .accent-line.yellow");
  ScrollTrigger.create({
    trigger: "footer .accent-line.pink",
    top: 'top 80%',
    onEnter: function onEnter() {
      footerAccentPink.classList.add('faded');
      footerAccentYellow.classList.add('faded');
    }
  });
}

var _default = footer;
exports["default"] = _default;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function highlightText() {
  function seeHandleScroll(el) {
    $(window).scroll(function () {
      var hT = $(el).offset().top,
          hH = $(el).outerHeight(),
          wH = $(window).height(),
          wS = $(this).scrollTop() - 100,
          padding = $(el).data('padding'),
          elWidth = $(el).find('span.text-width').width() + (padding / 2 - 10);

      if (wS > hT + hH - wH) {
        $(el).css('width', elWidth);
        $(el).css('padding-left', padding);
        $(el).css('padding-right', padding);
        $(el).addClass('loaded');
      }
    });
  }

  function seeTargetScroll(el) {
    $(el).each(function (i) {
      $(this).attr('id', 'scroll' + [i + 1]);
      var scrollEl = '#' + $(this).attr('id');
      seeHandleScroll(scrollEl);
    });
  }

  seeTargetScroll('.animateScroll');
}

var _default = highlightText;
exports["default"] = _default;

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function homeBanner() {
  var homeBanner = document.querySelector('.banner-home');
  var homeBannerImg = document.querySelector('.banner-home .main-image');
  var homeBannerText = document.querySelector('.banner-home h1');
  var homeBannerLogoYear = document.querySelector('.banner-home .logo-year');
  var homeBannerDate = document.querySelector('.banner-home .date');
  var homeBannerCTA = document.querySelector('.banner-home .btn');
  var homeBannerSquare = document.querySelector('.banner-home .pink-square'); // Angle

  homeBanner.classList.add('loaded'); // Square

  setTimeout(function () {
    homeBannerSquare.classList.add('animated');
  }, 800);
  gsap.to(".banner-home .pink-square", {
    scrollTrigger: {
      trigger: ".banner-home .pink-square",
      scrub: true
    },
    rotation: 180
  }); // Main Image

  setTimeout(function () {
    homeBannerImg.classList.add('animated');
  }, 1200); // Logo & Year

  setTimeout(function () {
    var handleHomeBannerLogoYear = Splitting({
      target: homeBannerLogoYear,
      by: 'items',
      matching: 'img'
    });
  }, 1500); // Date

  setTimeout(function () {
    homeBannerDate.classList.add('animated');
  }, 1800); // CTA

  if (homeBannerCTA) {
    setTimeout(function () {
      homeBannerCTA.classList.add('animated');
    }, 1800);
  } // Text


  setTimeout(function () {
    var handleHomeBannerText = Splitting({
      target: homeBannerText,
      by: 'items',
      matching: '.line-wrapper span'
    });
  }, 2000); // Accent

  var bannerHomeAccent = document.querySelector(".banner-home .accent-line");
  setTimeout(function () {
    ScrollTrigger.create({
      trigger: bannerHomeAccent,
      onEnter: function onEnter() {
        bannerHomeAccent.classList.add('fade-in');
      }
    });
  }, 2200);
  gsap.to(".banner-home .accent-line", {
    scrollTrigger: {
      trigger: ".banner-home .accent-line",
      scrub: true
    },
    y: 100
  });
}

function homeBannerInit() {
  if (document.querySelector('.banner-home')) {
    homeBanner();
  }
}

var _default = homeBannerInit;
exports["default"] = _default;

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function homeIntro() {
  var homeIntroHeading = document.querySelector('.intro-home h2');
  var homeIntroDesc = document.querySelector('.intro-home .content-wrapper');
  ScrollTrigger.matchMedia({
    "(min-width: 768px)": function minWidth768px() {
      ScrollTrigger.create({
        trigger: '.intro-home h2',
        start: 'top 65%',
        onEnter: function onEnter() {
          var handleHomeIntroHeading = Splitting({
            target: homeIntroHeading,
            by: 'lines'
          });
        }
      });
      ScrollTrigger.create({
        trigger: '.intro-home .content-wrapper',
        start: 'top 65%',
        onEnter: function onEnter() {
          var handleHomeIntroDesc = Splitting({
            target: homeIntroDesc,
            by: 'lines'
          });
        }
      });
    },
    "(max-width: 767px)": function maxWidth767px() {
      ScrollTrigger.create({
        trigger: '.intro-home h2',
        start: 'top 90%',
        onEnter: function onEnter() {
          homeIntroHeading.classList.add('fade-in');
        }
      });
      ScrollTrigger.create({
        trigger: '.intro-home .content-wrapper',
        start: 'top 90%',
        onEnter: function onEnter() {
          homeIntroDesc.classList.add('fade-in');
        }
      });
    }
  }); // Accent

  gsap.to(".intro-home .accent-line", {
    scrollTrigger: {
      trigger: ".intro-home .accent-line",
      scrub: true
    },
    y: -150
  });
}

function homeIntroInit() {
  if (document.querySelector('.intro-home')) {
    homeIntro();
  }
}

var _default = homeIntroInit;
exports["default"] = _default;

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function imageBreak() {
  // Accent
  gsap.to(".image-break .accent-dots", {
    scrollTrigger: {
      trigger: ".image-break .accent-dots",
      scrub: true
    },
    y: -400
  });
  gsap.to(".image-break", {
    scrollTrigger: {
      trigger: ".image-break",
      scrub: true
    },
    height: "75vw"
  });
}

function imageBreakInit() {
  if (document.querySelector('.image-break')) {
    imageBreak();
  }
}

var _default = imageBreakInit;
exports["default"] = _default;

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function innerBanner() {
  var innerBanner = document.querySelector('.banner-inner');
  setTimeout(function () {
    innerBanner.classList.add('animated');
  }, 800); // Pink Accents

  var pinkBannerSquare = document.querySelector('.banner-inner.pink .accent-square');
  var pinkBannerYellowTop = document.querySelector('.banner-inner.pink .accent-line.yellow.top');
  var pinkBannerYellowBottom = document.querySelector('.banner-inner.pink .accent-line.yellow.bottom');
  var pinkBannerWhite = document.querySelector('.banner-inner.pink .accent-line.white');
  var pinkBannerDots = document.querySelector('.banner-inner.pink .accent-dots');

  if (pinkBannerSquare) {
    setTimeout(function () {
      pinkBannerSquare.classList.add('loaded');
      pinkBannerWhite.classList.add('loaded');
      pinkBannerDots.classList.add('loaded');
    }, 2000);
    setTimeout(function () {
      pinkBannerYellowTop.classList.add('loaded');
      pinkBannerYellowBottom.classList.add('loaded');
    }, 2600);
  } // Green Accents


  var greenBannerSquare = document.querySelector('.banner-inner.green .accent-square');
  var greenBannerYellow = document.querySelector('.banner-inner.green .accent-line.yellow');
  var greenBannerWhite = document.querySelector('.banner-inner.green .accent-line.white');
  var greenBannerDots = document.querySelector('.banner-inner.green .accent-dots');

  if (greenBannerSquare) {
    setTimeout(function () {
      greenBannerSquare.classList.add('loaded');
      greenBannerWhite.classList.add('loaded');
    }, 2000);
    setTimeout(function () {
      greenBannerYellow.classList.add('loaded');
      greenBannerDots.classList.add('loaded');
    }, 2600);
  } // Purple Accents


  var purpleBannerSquare = document.querySelector('.banner-inner.purple .accent-square');
  var purpleBannerYellow = document.querySelector('.banner-inner.purple .accent-line.yellow');
  var purpleBannerWhite = document.querySelector('.banner-inner.purple .accent-line.white');
  var purpleBannerDots = document.querySelector('.banner-inner.purple .accent-dots');

  if (purpleBannerSquare) {
    setTimeout(function () {
      purpleBannerSquare.classList.add('loaded');
      purpleBannerWhite.classList.add('loaded');
    }, 2000);
    setTimeout(function () {
      purpleBannerYellow.classList.add('loaded');
      purpleBannerDots.classList.add('loaded');
    }, 2600);
  }
}

function innerBannerInit() {
  if (document.querySelector('.banner-inner')) {
    innerBanner();
  }
}

var _default = innerBannerInit;
exports["default"] = _default;

},{}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function keynoteHome() {
  var keynoteHome = document.querySelector('.keynote-home');
  var keynoteHomeImg = document.querySelector('.keynote-home .img-wrapper');
  var keynoteHomeContent = document.querySelector('.keynote-home .block-wrapper');
  ScrollTrigger.create({
    trigger: keynoteHome,
    start: "top 50%",
    onEnter: function onEnter() {
      keynoteHomeImg.classList.add('animated');
      keynoteHomeContent.classList.add('animated');
    }
  });
}

function keynoteHomeInit() {
  if (document.querySelector('.keynote-home')) {
    keynoteHome();
  }
}

var _default = keynoteHomeInit;
exports["default"] = _default;

},{}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function keynoteInner() {
  var keynoteInner = document.querySelector('.keynote-inner');
  ScrollTrigger.create({
    trigger: keynoteInner,
    start: "top 60%",
    onEnter: function onEnter() {
      keynoteInner.classList.add('animated');
    }
  });
}

function keynoteInnerInit() {
  if (document.querySelector('.keynote-inner')) {
    keynoteInner();
  }
}

var _default = keynoteInnerInit;
exports["default"] = _default;

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function navigation() {
  var navLogo = document.querySelector('header .logo');
  var navUl = document.querySelector('header nav ul');
  var mobileTrigger = document.querySelector('.mobile-menu-trigger');
  setTimeout(function () {
    if (navUl) {
      var handleNavUl = Splitting({
        target: navUl,
        by: 'items',
        matching: 'li'
      });
    }

    var handleNavLogo = Splitting({
      target: navLogo,
      by: 'items',
      matching: 'a'
    });

    if (mobileTrigger) {
      mobileTrigger.classList.add('loaded');
    }
  }, 1800);
}

var _default = navigation;
exports["default"] = _default;

},{}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ticketWidget() {
  // Accents
  gsap.to(".ticket-widget .accent-line.purple", {
    scrollTrigger: {
      trigger: ".ticket-widget .accent-line.purple",
      scrub: true,
      start: "top 120%",
      end: "bottom -20%"
    },
    y: 100
  });
  gsap.to(".ticket-widget .accent-line.yellow", {
    scrollTrigger: {
      trigger: ".ticket-widget .accent-line.yellow",
      start: "top 120%",
      end: "bottom -20%",
      scrub: true
    },
    y: -100
  });
  gsap.to(".ticket-widget .accent-square.yellow", {
    scrollTrigger: {
      trigger: ".ticket-widget .accent-square.yellow",
      end: "bottom -40%",
      scrub: true
    },
    rotation: 60
  });
}

function ticketWidgetInit() {
  if (document.querySelector('.ticket-widget')) {
    ticketWidget();
  }
}

var _default = ticketWidgetInit;
exports["default"] = _default;

},{}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function twitterGrid() {
  var twitterTitle = document.querySelector('.twitter-grid h2');
  var tweets = document.querySelector('.twitter-grid .tweets');
  ScrollTrigger.matchMedia({
    "(min-width: 768px)": function minWidth768px() {
      ScrollTrigger.create({
        trigger: '.twitter-grid h2',
        start: 'top 65%',
        onEnter: function onEnter() {
          var handleTwitterTitle = Splitting({
            target: twitterTitle,
            by: 'lines'
          });
        }
      });
    },
    "(max-width: 767px)": function maxWidth767px() {
      ScrollTrigger.create({
        trigger: '.twitter-grid h2',
        start: 'top 80%',
        onEnter: function onEnter() {
          twitterTitle.classList.add('fade-in');
        }
      });
    }
  });
  ScrollTrigger.create({
    trigger: '.twitter-grid .tweets',
    start: 'top 65%',
    onEnter: function onEnter() {
      var handleTweets = Splitting({
        target: tweets,
        by: 'items',
        matching: '.tweet-block'
      });
    }
  }); // Accent

  gsap.to(".twitter-grid .accent-line", {
    scrollTrigger: {
      trigger: ".twitter-grid .accent-line",
      scrub: true
    },
    y: -200
  });
}

function twitterGridInit() {
  if (document.querySelector('.twitter-grid')) {
    twitterGrid();
  }
}

var _default = twitterGridInit;
exports["default"] = _default;

},{}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var speakers = [{
  name: 'Adam Kuban',
  title: 'Senior Social Media Director, NYC & Company',
  img: 'https://crowdriff.com/wp-content/uploads/adam-kuban-main.png'
}, {
  name: 'Ashley Lyn Olson',
  title: 'Founder, wheelchairtraveling.com',
  img: 'https://crowdriff.com/wp-content/uploads/ashley-lyn-olson-main.png'
}, {
  name: 'Beril Gutierrez',
  title: 'Senior Manager of Social Media, Discover The Palm Beaches',
  img: 'https://crowdriff.com/wp-content/uploads/beril-gutierrez-main.png'
}, {
  name: 'Brandon Billings',
  title: 'VP, Social Media & Content Strategy, MMGY Global',
  img: 'https://crowdriff.com/wp-content/uploads/brandon-billings-main.png'
}, {
  name: 'Deanna Wampler',
  title: 'Social Media Specialist, Indigenous Tourism BC (ITBC)',
  img: 'https://crowdriff.com/wp-content/uploads/deanna-wampler-main.png'
}, {
  name: 'Diogo Paciência',
  title: 'Digital Marketing Manager, European Travel Commission',
  img: 'https://crowdriff.com/wp-content/uploads/diogo-paciencia-main.png'
}, {
  name: 'Erin Brown',
  title: 'Digital Analytics Strategist, VERB Interactive',
  img: 'https://crowdriff.com/wp-content/uploads/erin-brown-main-1.png'
}, {
  name: 'Helen Dennis',
  title: 'Content Specialist, Experience Columbia SC',
  img: 'https://crowdriff.com/wp-content/uploads/helen-dennis-main.png'
}, {
  name: 'Jake Brown',
  title: 'Content and Digital Marketing Strategist Visit South Bend Mishawaka',
  img: 'https://crowdriff.com/wp-content/uploads/jake-brown-main.png'
}, {
  name: 'Jeff Jenkins',
  title: 'Content Creator and Travel Journalist, Chubby Diaries',
  img: 'https://crowdriff.com/wp-content/uploads/jeff-jenkins-main.png'
}, {
  name: 'John Freeman',
  title: 'Social Media Specialist, Simpleview',
  img: 'https://crowdriff.com/wp-content/uploads/freeman-john-main.png'
}, {
  name: 'Katie Langton',
  title: 'Social Media & Content Strategist, VERB Interactive',
  img: 'https://crowdriff.com/wp-content/uploads/katie-langton-main-1.png'
}, {
  name: 'Katie Utken',
  title: 'Marketing and Communications Manager, Hamilton County Tourism (Indiana)',
  img: 'https://crowdriff.com/wp-content/uploads/katie-utken-main.png'
}, {
  name: 'Kelsey Carmichael',
  title: 'Director of Marketing, Experience Columbia SC',
  img: 'https://crowdriff.com/wp-content/uploads/kelsey-carmichael-main.png'
}, {
  name: 'KJ Philp',
  title: 'Content Manager, Visit Phoenix',
  img: 'https://crowdriff.com/wp-content/uploads/kj-philp-main.png'
}, {
  name: 'Laurie Dempster',
  title: 'Digital and Social Media Lead, Newfoundland and Labrador Tourism',
  img: 'https://crowdriff.com/wp-content/uploads/Laurie-Dempster-main.png'
}, {
  name: 'Lisa Fernandez',
  title: 'Marketing Manager, Visit Northern Tasmania',
  img: 'https://crowdriff.com/wp-content/uploads/lisa-fernandez-main.png'
}, {
  name: 'Mackenzie Bromley',
  title: 'Director of Social Media, MMGY Global',
  img: 'https://crowdriff.com/wp-content/uploads/Mackenzie-Bromley-main.png'
}, {
  name: 'Mark Hermes',
  title: 'Digital Marketing & Social Media Manager, Explore St Louis',
  img: 'https://crowdriff.com/wp-content/uploads/mark-hermes-main.png'
}, {
  name: 'Matthew Scales',
  title: 'Public Relations Specialist, Maryland Department of Commerce Office of Tourism',
  img: 'https://crowdriff.com/wp-content/uploads/matthew-scales-main.png'
}, {
  name: 'Meghan Tabor',
  title: 'Marketing & Destination Director, Tourism Revelstoke',
  img: 'https://crowdriff.com/wp-content/uploads/meghan-tabor-main.png'
}, {
  name: 'Melissa Kinney',
  title: 'Integrated Creative Producer, Utah Office of Tourism',
  img: 'https://crowdriff.com/wp-content/uploads/melissa-kinney-main.png'
}, {
  name: 'Michelle McAleese',
  title: 'Senior Marketing Strategist, Tourism Kamloops',
  img: 'https://crowdriff.com/wp-content/uploads/michelle-mcaleese-main.png'
}, {
  name: 'Nikki Theissen',
  title: 'Vice President of Partner & Visitor Relations, Discover Long Island',
  img: 'https://crowdriff.com/wp-content/uploads/nikki-theissen-main.png'
}, {
  name: 'Nina Colarić Cvirn',
  title: 'Head of Social Media Communications, Slovenian Tourist Board',
  img: 'https://crowdriff.com/wp-content/uploads/nina-colaric-cvirn-main.png'
}, {
  name: 'Sarah Foster',
  title: 'Director of Communications & TV/Film, Oneida County Tourism',
  img: 'https://crowdriff.com/wp-content/uploads/sarah-foster-main.png'
}, {
  name: 'Shannon Lowery',
  title: 'Content & Social Media Manager, Visit Savannah',
  img: 'https://crowdriff.com/wp-content/uploads/shannon-lowery-main.png'
}];

function shuffle(array) {
  var currentIndex = array.length,
      randomIndex; // While there remain elements to shuffle...

  while (currentIndex != 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--; // And swap it with the current element.

    var _ref = [array[randomIndex], array[currentIndex]];
    array[currentIndex] = _ref[0];
    array[randomIndex] = _ref[1];
  }

  return array;
}

function homepageSpeakers() {
  shuffle(speakers);
  var feauturedSpeakers = speakers.slice(0, 7);
  var wrapper = document.querySelector('.homepage-speakers .speakers-wrapper');
  feauturedSpeakers.forEach(function (speaker) {
    var block = document.createElement('div');
    block.classList.add('speaker');
    var imgWrapper = document.createElement('div');
    imgWrapper.classList.add('img-wrapper');
    var img = document.createElement('img');
    img.src = speaker.img;
    imgWrapper.appendChild(img);
    var name = document.createElement('h4');
    name.innerHTML = speaker.name;
    var title = document.createElement('p');
    title.innerHTML = speaker.title;
    block.appendChild(imgWrapper);
    block.appendChild(name);
    block.appendChild(title);
    wrapper.appendChild(block);
  }); // Animations

  var speakersDots = document.querySelector('.homepage-speakers .title-wrapper .accent');
  ScrollTrigger.create({
    trigger: speakersDots,
    onEnter: function onEnter() {
      speakersDots.classList.add('faded');
    }
  });
  ScrollTrigger.create({
    trigger: '.homepage-speakers .speakers-wrapper',
    start: 'top 65%',
    onEnter: function onEnter() {
      var handleSpeakers = Splitting({
        target: '.homepage-speakers .speakers-wrapper',
        by: 'items',
        matching: '.speaker'
      });
    }
  });
}

function homepageSpeakersInit() {
  if ($('.homepage-speakers').length) {
    homepageSpeakers();
  }
}

var _default = homepageSpeakersInit;
exports["default"] = _default;

},{}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function resources() {
  $('ul.tabs li a').on('click', function (e) {
    e.preventDefault();
    var tab_id = $(this).parent().attr('data-tab');
    $('ul.tabs li').removeClass('current');
    $(this).parent().addClass('current');

    if (tab_id == 'tab-0') {
      $('.tab-content').css('display', 'block');
    } else {
      $('.tab-content').css('display', 'none').removeClass('current');
      $("#" + tab_id).addClass('current').css('display', 'block');
    }
  });
  $(document).on('submit', 'form#see-password-2021', function (e) {
    e.preventDefault();
    var passwordVal = $('#see-password-2021 input[type="password"]').val();

    if (passwordVal == 'SEE2021') {
      $('.resources-password').remove();
      $('.resources').css('display', 'block');
      localStorage.setItem('resources', 'correct');
    } else {
      $('#see-password-2021 .error').css('display', 'block');
    }
  });
  var passwordStatus = localStorage.getItem('resources');

  if (passwordStatus == 'correct') {
    $('.resources-password').remove();
    $('.resources').css('display', 'block');
  } // Coming Soon for Keynote


  var speakersParagraph = document.querySelectorAll('.speakers p');
  speakersParagraph.forEach(function (p) {
    if (p.innerHTML == 'Derreck Kayongo') {
      var content = p.closest('.resource-block').querySelector('.content-wrapper');
      var comingSoon = document.createElement('div');
      comingSoon.classList.add('video-availability');
      var text = document.createElement('p');
      text.innerHTML = 'This keynote will be available until February&nbsp;17,&nbsp;2022.';
      comingSoon.appendChild(text);
      content.appendChild(comingSoon);
    }
  }); // Mobile Dropdown

  function mobileNav() {
    $('.mobile-label').click(function () {
      $('ul.tabs').toggleClass('open');
    });
    $('.tab-link a').click(function () {
      $('ul.tabs').removeClass('open');
      var label = this.innerHTML;
      var labelWrapper = document.querySelector('.mobile-label');
      labelWrapper.innerHTML = label;
    });
  }

  mobileNav();
}

function resourcesInit() {
  if (document.querySelector('.resources')) {
    resources();
  }
}

var _default = resourcesInit;
exports["default"] = _default;

},{}],20:[function(require,module,exports){
"use strict";

var _animations = _interopRequireDefault(require("./animations"));

var _homepageSpeakers = _interopRequireDefault(require("./homepageSpeakers"));

var _resources = _interopRequireDefault(require("./resources"));

var _wistiaPopover = _interopRequireDefault(require("./wistiaPopover"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var seeApp = {};

seeApp.init = function () {
  seeApp.navigation();
  seeApp.carousels();
  seeApp.accordion();
  seeApp.agenda();
  seeApp.speakers();
  (0, _resources["default"])();
};

seeApp.navigation = function () {
  var mobileTrigger = document.querySelector('.mobile-menu-trigger');
  var nav = document.querySelector('header nav');
  var body = document.querySelector('body');
  var cta = document.querySelector('header nav .btn');

  if (mobileTrigger) {
    mobileTrigger.addEventListener('click', function () {
      mobileTrigger.classList.toggle('open');
      nav.classList.toggle('open');
      body.classList.toggle('noscroll');
    });
  }

  if (cta) {
    cta.addEventListener('click', function () {
      mobileTrigger.classList.remove('open');
      nav.classList.remove('open');
      body.classList.remove('noscroll');
    });
  }
};

seeApp.carousels = function () {
  var twitterSlider = $('.twitter-grid .tweets');
  twitterSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    arrows: false,
    dots: true,
    mobileFirst: true,
    responsive: [{
      breakpoint: 767,
      settings: "unslick"
    }]
  });
};

seeApp.accordion = function () {
  $('.accordion-item > button').on('click', function () {
    if ($(this).parent().hasClass('active')) {
      $('.accordion-item').removeClass('active');
      $('.item-content').slideUp();
    } else {
      $('.accordion-item').removeClass('active');
      $('.item-content').slideUp();
      $(this).parent().addClass('active');
      $(this).parent().find('.item-content').slideDown();
    }
  });
};

seeApp.agenda = function () {
  ScrollTrigger.create({
    trigger: '.agenda',
    start: 'top 65%',
    onEnter: function onEnter() {
      var handleSpeakers = Splitting({
        target: '.agenda .container',
        by: 'items',
        matching: '.time-block'
      });
    }
  });
  $('button.item-wrapper').click(function () {
    $(this).toggleClass('open');
    $(this).find('.item-description').slideToggle();
  });
};

seeApp.speakers = function () {
  $(window).on('load', function () {
    var hash = window.location.hash;

    if (window.location.href.indexOf('speakers') > -1 && hash) {
      var newHash = hash.replace('#', '');
      var directPopup = document.querySelector(".speaker-popup[data-id=".concat(newHash, "]"));
      var hashSpeaker = document.querySelector(".speaker-wrapper[data-speaker=".concat(newHash, "]"));
      hashSpeaker.scrollIntoView();
      setTimeout(function () {
        directPopup.classList.add('active');
      }, 1000);
    }
  });
  ScrollTrigger.create({
    trigger: '.speakers',
    start: 'top 65%',
    onEnter: function onEnter() {
      var handleSpeakers = Splitting({
        target: '.speakers .container',
        by: 'items',
        matching: '.speaker-wrapper'
      });
    }
  });
  $('button.speaker-trigger').click(function () {
    $(this).parent().find('.speaker-popup').addClass('active');
  });
  $('button.close-speaker-popup').click(function () {
    $(this).parent().parent().removeClass('active');
  });
  var clickTarget = $('.speaker-popup');
  $('body').mouseup(function (e) {
    if (e.target.id != clickTarget.attr('id') && !clickTarget.has(e.target).length) {
      $('.speaker-popup').removeClass('active');
    }
  });
  var popupSliders = document.querySelectorAll('.popup-images');
  popupSliders.forEach(function (slider) {
    $(slider).slick({
      arrows: false,
      dots: true,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000
    });
  });
};

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector('.banner-home')) {
    var body = document.querySelector('body');
    var loader = document.querySelector('#loader');
    body.classList.add('noscroll');
    seeApp.init();
    (0, _homepageSpeakers["default"])();
    setTimeout(function () {
      body.classList.remove('noscroll');
      loader.classList.remove('active');
      (0, _animations["default"])();
    }, 4000);
  } else {
    seeApp.init();
    (0, _animations["default"])();
    (0, _wistiaPopover["default"])();
  }
});

},{"./animations":1,"./homepageSpeakers":18,"./resources":19,"./wistiaPopover":21}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function wistiaPopover() {
  $.fn.cssGet = function (propertyArray) {
    //create an output variable and limit this function to finding info for only the first element passed into the function
    var output = {},
        self = this.eq(0); //iterate through the properties passed into the function and add them to the output variable

    for (var i = 0, len = propertyArray.length; i < len; i++) {
      output[propertyArray[i]] = this.css(propertyArray[i]);
    }

    return output;
  };

  function makePopover(elem, mediaID) {
    $(elem).addClass("wistia_embed wistia_async_" + mediaID + " popover=true popoverContent=link");
    Wistia.embeds.setup();
    var popoverAction = {};

    popoverAction[mediaID] = function (video) {
      video.popover.show();
      video.play();
    };

    window._wq = window._wq || [];

    _wq.push(popoverAction);
  }

  $(".video-popup-wrapper").on("click", function (e) {
    e.preventDefault();
    var vidID = $(this).attr("data-video");

    if (!$(this).hasClass('relative')) {
      var vidBtn = $(this).find('a');
      var vidBtnCSS = vidBtn.cssGet(['position', 'top', 'left', 'height', 'width']);

      if (vidBtnCSS.position == 'absolute') {
        $(this).css('position', vidBtnCSS.position);
        $(this).css('top', vidBtnCSS.top);
        $(this).css('left', vidBtnCSS.left);
        $(this).css('height', vidBtnCSS.height);
        $(this).css('width', vidBtnCSS.width);
        $(vidBtn).css('position', 'relative');
        $(vidBtn).css('top', 0);
        $(vidBtn).css('left', 0);
      }
    }

    makePopover(this, vidID);
  });
}

function wistiaPopoverInit() {
  if ($('.video-popup-wrapper').length) {
    wistiaPopover();
  }
}

var _default = wistiaPopoverInit;
exports["default"] = _default;

},{}]},{},[20]);
